import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryBadStatusListResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setStatusList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useStatusListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.STATUS_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryBadStatusListResponse>) => {
          if (res.data.status === true) {
            dispatch(setStatusList({ data: res.data.data }));
          } else {
            dispatch(setStatusList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
